<template>
  <div class="dragBox">
    <k-dialog class="dragBoxModal" ref="drahBoxDialog" :options="{ title: dragTitle, center: true, width: '80%', height: 900, top: '0', destroyOnClose: false, isCanClickClose: false, showClose: false, buttons: [{ text: '确定', handler: confirmDragBox }] }">
      <div class="dragBox">
        <div class="dragHeader">
          <span class="dragBoxTip" v-html="dragTip"></span>
        </div>
        <div class="drag-content">
          <div class="leftBox commonBox">
            <div class="areaTitle">影像类别</div>
            <div class="areaContent">
              <div v-for="(item, index) in showImgArr" :key="'title' + item.IMG_CLS + index" class="areaContentItem">
                <div :class="[{ clsBox: true, activated: index == clickIndex }]" v-if="filterImgClsArr.indexOf(item.IMG_CLS) === -1" @click="changeImgCls(index)">
                  <span class="imgTitle">{{ item.IMG_CLS + item.IMG_CLS_NAME }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="imgBox commonBox">
            <div class="areaTitle">
              已分类
              <div class="imgClsName">{{ currentImg.IMG_CLS + "-" + currentImg.IMG_CLS_NAME }}</div>
            </div>
            <div class="areaContent">
              <div
                class="imageCon"
                @dragover.prevent
                v-for="(obj, j) in currentImg.IMG_DATA"
                :key="'imageCon' + obj.IMG_CLS + j"
                @drop="handleDrapEnd($event, j, currentImg.IMG_CLS)"
                @dragover="dragenter($event, j, currentImg.IMG_CLS)"
                @dragleave="dragleave($event, j, currentImg.IMG_CLS)"
                @click="clickPageNums(currentImg.IMG_CLS, obj, j)"
              >
                <img v-if="currentImg.IMG_FMT === '5'" class="imagesDiv cursor smallPdf" src="@img/newCode/imgUploadBox/pdfFile.svg" draggable="true" />
                <img v-else class="imagesDiv" :src="getSrc(obj)" @dragstart="handleDrapStart($event, obj, j, currentImg.IMG_CLS)" draggable="true" />
                <span class="seq">{{ j + 1 + (obj.IMG_FMT === "5" ? "-无需分类" : "") }}</span>
                <!-- <div class="uploadListCover">
                  <img src="../../assets/images/examine/check.png" @click="showExamplesFn(currentImg, j)" class="cursor" />
                  <img src="../../assets/images/examine/delete.png" @click="removeImg(currentImg.IMG_CLS, obj, j)" class="cursor" />
                </div> -->
              </div>
              <div
                @dragover.prevent
                @dragstart="noHandleDrapStart($event)"
                v-if="!currentImg.IMG_DATA.length"
                class="placeHolderDiv"
                @drop="handleDrapEnd($event, 0, currentImg.IMG_CLS)"
                @dragover="dragenterPlaceDiv($event, -1, currentImg.IMG_CLS)"
                @dragleave="dragleavePlaceDiv($event, -1, currentImg.IMG_CLS)"
              >
                当前无表单
              </div>
            </div>
          </div>
          <div class="unknowImgBox commonBox">
            <div class="areaTitle unknowTitle">
              待分类表单({{ getLength() }})
              <span class="subTitle">（可拖拽至左边相应的分类）</span>
            </div>
            <div class="areaLeft">
              <div class="unknowImglist" v-for="(unknowImg, unknowImgIndex) in unknowImgArr" :key="'unknowImgList' + unknowImg.IMG_CLS + unknowImgIndex">
                <div
                  class="imageCon"
                  v-for="(pageObj, k) in unknowImg.IMG_DATA"
                  :key="'unknowImgCon' + k + pageObj.IMG_CLS"
                  @dragstart="handleDrapStart($event, pageObj, k, unknowImg.IMG_CLS)"
                  @drop="handleDrapEnd($event, k, unknowImg.IMG_CLS)"
                  @dragover="dragenter($event)"
                  @dragleave="dragleave($event)"
                  @click="clickPageNums(unknowImg.IMG_CLS, pageObj, k)"
                  draggable="true"
                  @dragover.prevent
                >
                  <img v-if="pageObj.IMG_FMT === '5'" class="imagesDiv cursor smallPdf" src="@img/newCode/imgUploadBox/pdfFile.svg" />
                  <img v-else class="imagesDiv" :src="getSrc(pageObj)" />
                  <span :class="[pageNum == k ? 'activatedPage seq' : 'seq']">未分类{{ k + 1 }}</span>
                </div>
                <div @dragover.prevent @dragstart="noHandleDrapStart($event)" v-if="!unknowImg.IMG_DATA.length" class="placeHolderDiv" @drop="handleDrapEnd($event, 0, unknowImg.IMG_CLS)" @dragover="dragenterPlaceDiv($event)" @dragleave="dragleavePlaceDiv($event)">当前无表单</div>
              </div>
            </div>
            <div class="areaRight">
              <img v-if="currentPageObj && currentPageObj.IMG_FMT === '5'" class="imagesDiv cursor smallPdf" src="@img/newCode/imgUploadBox/pdfFile.svg" />
              <img v-if="currentPageObj && currentPageObj.IMG_FMT !== '5'" class="pageDiv" :src="getSrc(currentPageObj)" />
              <div class="uploadListCover" v-if="currentPageObj">
                <!-- <img src="../../assets/images/examine/check.png" @click="showExamplesFn(currentPageObj, pageNum)" class="cursor" />
                 -->
                <img src="@img/newCode/imgUploadBox/check.png" @click="showExamplesFn(currentPageObj)" class="cursor" />
                <img src="@img/newCode/imgUploadBox/delete.png" @click="removeImg(currentPageCls, pageNum)" class="cursor" />
              </div>
              <div class="midImgTitle">预览视图-未分类{{ pageNum + 1 }}</div>
            </div>
          </div>
        </div>
        <!-- <div class="modal-footer">
            <div class="btns">
              <div class="btn confirm" @click="confirmDragBox">
                确定
              </div>
            </div> -->
        <!-- </div> -->
      </div>
    </k-dialog>
    <!-- 图片放大弹窗 -->
    <showBigImg class="showBigImgBox" :isShowBigImg="isShowBigImg" :fileSrc="getSrc(bigPageObj)" :title="bigPageObj.IMG_CLS_NAME || '预览'" :isPdf="bigPageObj.IMG_FMT === '5'" @cancelBigImg="cancelBigImg" v-if="isShowBigImg"></showBigImg>
  </div>
</template>

<script>
import showBigImg from "./showBigImg.vue";
import kDialog from "../../common/dialog.vue";
import imgTools from "@/components/imageNode/child/imgTools";

export default {
  components: {
    showBigImg,
    kDialog
  },
  props: {
    dragTitle: {
      type: String,
      default: "表单分类确认"
    },
    dragTip: {
      type: String,
      default: `请核对表单自动识别结果:
        1.左侧表单类别可点击切换查看对应表单，如分类下的表单分类错误，则可将错误表单拖拽到最右侧未识别表单区域。
        2.若右侧存在待分类影像，请先在左侧切换到正确分类后再将待分类表单拖拽到中间区域，手动拖拽时需重点注意该分类下的表单顺序是否正确。`
    },
    imgClsArr: {
      type: Array,
      default: () => [
        {
          IMG_CLS: "X9999",
          IMG_CLS_NAME: "未识别影像",
          IMG_DATA: []
        }
      ]
    },
    filterImgClsArr: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentImg: {
        IMG_CLS: "001",
        IMG_CLS_NAME: "类别1",
        IMG_DATA: []
      },
      clickIndex: 0, //影像类别下标
      isShow: false,
      currentDragItem: {}, //当前正在拖动的元素信息
      currentDragItemIndex: -1, //当前拖动元素在帧数数组里的下标
      isLoading: true,
      bigPageIndex: 0,
      isShowBigImg: false,
      bigPageObj: {},
      currentPageObj: null,
      pageNum: "",
      currentPageCls: "", //预览的imgcls
      pushDirection: "" //插入顺序
    };
  },
  computed: {
    showImgArr: {
      get: function () {
        //当前类型（表单/图像）的影像数组 过滤
        return this.imgClsArr.filter(v => v.IMG_CLS !== "x9999");
      },
      set: function (newValue) {
        consoleLog("触发showImgArr计算属性set方法", newValue);
      }
    },
    unknowImgArr: {
      get: function () {
        // 未识别影像数组 过滤
        return this.imgClsArr.filter(v => v.IMG_CLS === "x9999");
      },
      set: function (newValue) {
        consoleLog("触发计算属性unknowImgArr的set方法", newValue);
      }
    }
  },
  watch: {},
  mounted () {
    this.currentImg = this.imgClsArr[0];
    this.autoClickFirst();
    this.$refs.drahBoxDialog.open();
  },
  methods: {
    // cancelDragBox () {
    //   // consoleLog("取消分类窗口");
    //   // this.beforeClose()
    //   //   .then(() => {
    //   //     this.isShow = false;
    //   //     this.isLoading = false;
    //   //     this.$emit("cancelDragBox");
    //   //   })
    //   //   .catch(err => {
    //   //     this.isShow = true;
    //   //     consoleLog("无法关闭，还有待分类表单");
    //   //   });
    //   //取消也走确认逻辑，因为分类拖拽或者删除后必须保存流水数据
    //   this.confirmDragBox();
    // },
    confirmDragBox () {
      return this.beforeClose()
        .then(() => {
          //允许关闭
          // this.isShow = false;
          this.$emit("confirmDragBox");
          return true;
        })
        .catch(err => {
          //不允许关闭
          // consoleLog("无法关闭，还有待分类表单");
          return false;
        });
    },
    getSrc (item) {
      if (item.localImgUrl && item.localImgUrl.startsWith("blob:http:")) {
        return item.localImgUrl;
      }
      if (!item.imgSrc) {
        return "";
      }
      let base64Str = "data:image/jpg;base64," + item.imgSrc.replace(/data:(.*?),/, "");
      let localImgUrl = imgTools.getBase64URL(base64Str);
      item.localImgUrl = localImgUrl;
      return item.localImgUrl;
    },
    changeImgCls (index) {
      // consoleLog("切换影像类别");
      this.currentImg = this.imgClsArr[index];
      this.clickIndex = index;
      this.$emit("downloadOneClsImg", this.currentImg);
    },
    getLength () {
      return (this.unknowImgArr && this.unknowImgArr[0] && this.unknowImgArr[0].IMG_DATA.length) || 0;
    },
    autoClickFirst () {
      let firstImg = this.unknowImgArr[0] && this.unknowImgArr[0].IMG_DATA[0];
      if (firstImg) {
        this.clickPageNums(this.unknowImgArr[0].IMG_CLS, this.unknowImgArr[0].IMG_DATA[0], 0);
      }
    },
    clickPageNums (imgCls, pageObj, k) {
 
      //获取不同文件的文件头前3个字作为判断依据
      let preFix = pageObj.imgSrc&&pageObj.imgSrc.substring(0,3);
      // fileHeader.set("/9j", "JPG")
      // fileHeader.set("iVB", "PNG")
      // fileHeader.set("Qk0", "BMP")
      // fileHeader.set("SUk", "TIFF")
      // fileHeader.set("JVB", "PDF")
      // fileHeader.set("UEs", "OFD")
      if(preFix === "JVB"){
        pageObj.IMG_FMT = "5";
        return;
      }
      this.currentPageCls = imgCls;
      this.currentPageObj = pageObj;
      this.pageNum = k;
    },
    cleanPageNums () {
      this.currentPageCls = null;
      this.currentPageObj = null;
      this.pageNum = -1;
      this.autoClickFirst();
    },
    // 开始拖拽元素
    handleDrapStart (evt, obj, index, IMG_CLS) {
      // consoleLog("开始拖放evt", IMG_CLS);
      //保存当前拖拽表单的类别，表单在影像IMG_DATA数组中的下标
      this.currentDragItemImgCls = IMG_CLS;
      this.currentDragItemIndex = index;
      this.currentDragItem = obj;
      //挂载数据
      evt.dataTransfer.setData("draggable", "1");
    },
    // 监听拖拽元素结束
    handleDrapEnd (evt, targetIndex, targetImgCls) {
    //   consoleLog("拖拽元素目标imgcls", targetImgCls);
      if (!this.validateDragDiv(evt)) {
        return;
      }
      //先校验，校验通过了才移动
      let that = this;
      that.$emit("imgValidate", flag => {
        if (!flag) {
          return;
        }
        // consoleLog("监听拖拽元素结束，新图片位置", that.pushDirection);
        let imageConTarget = that.getParentNode(evt);
        that.moveItem(evt, targetIndex, targetImgCls);
        // imageConTarget.style.background = "#fff";
        imageConTarget.classList.remove("drop-up");
        imageConTarget.classList.remove("drop-down");
      });
    },
    moveItem (evt, targetIndex, targetImgCls) {
      //原数组
      let sourceImgClsInfo = this.imgClsArr.filter(v => v.IMG_CLS === this.currentDragItemImgCls);
      sourceImgClsInfo = sourceImgClsInfo[0] || {};

      let moveSrcData = sourceImgClsInfo.IMG_DATA[this.currentDragItemIndex];

      let targetImgClsInfo = this.imgClsArr.filter(v => v.IMG_CLS === targetImgCls);
      targetImgClsInfo = targetImgClsInfo[0] || {};
      let isSameCls = targetImgCls ==  this.currentDragItemImgCls;
      //移动前 需要增加判断
      if(sourceImgClsInfo.IMG_FMT === "5"){
        this.alert("操作失败:禁止移动PDF!");
        return false;
      }else if(targetImgClsInfo.IMG_DATA.length && targetImgClsInfo.IMG_FMT === "5"){
        this.alert("操作失败:目标影像已上传PDF,禁止操作!");
        return false;
      }
      if(isSameCls && this.currentDragItemIndex == targetIndex){
        //原地不动
        consoleLog("原地不动");
        return;
      }
      let destClsData = {};
      let newIndex = targetIndex;
      if(targetIndex === 0 && !targetImgClsInfo.IMG_DATA.length){
        //新类别下无影像 则新的pagenum强制为第一页
        targetIndex = "1";
      }else if (this.pushDirection == "next") {
        let destClsData = targetImgClsInfo.IMG_DATA[targetIndex]||{};
        if(!destClsData.PAGE_NUM){
          targetIndex = "1";
        }else{
          //假如需要放到第二页，移动元素到第1个元素下半部分
          //targetIndex为0时，本地数组新位置index为1，调整顺序的接口，pagenum：2 代表第二个
          targetIndex = targetIndex + 2;
          newIndex++;
        }
        //处理数组边界问题
        if(isSameCls && targetIndex>=targetImgClsInfo.IMG_DATA.length+1){
          //挪到最后一页
          targetIndex = targetImgClsInfo.IMG_DATA.length;
          newIndex =  targetImgClsInfo.IMG_DATA.length - 1;
        }
      } else if (this.pushDirection == "prev") {
        //移动到上一个影像
        let destClsData = targetImgClsInfo.IMG_DATA[targetIndex]||{};
        if(!destClsData.PAGE_NUM){
          targetIndex = "1";
        }else{
          //假如需要放到第二页，移动元素到第二个元素上半部分
          //此时targetIndex为1时，本地数组新位置index为1，调整顺序的接口，pagenum：2 代表第二个
          targetIndex = targetIndex + 1;
        }
      }
      // consoleLog("移动图片，当前图片下标currentDragItemIndex==", this.currentDragItemIndex);
      consoleLog("当前拖动的图片类别是",  this.currentDragItemImgCls);
      consoleLog("目标targetIndex", targetIndex);
      consoleLog("目标newIndex", newIndex);
      consoleLog("目标类别已有图片长度", _.get(targetImgClsInfo,"IMG_DATA.length"));
     
      this.$emit(
        "dragBoxEnd",
        {
          OLD_IMG_CLS: sourceImgClsInfo.IMG_CLS,
          IMG_FMT: sourceImgClsInfo.IMG_FMT || "3",
          OLD_PAGE_NUM: moveSrcData.PAGE_NUM + "",
          NEW_IMG_CLS: targetImgClsInfo.IMG_CLS,
          NEW_PAGE_NUM: targetIndex+"" //指定新类别的位置 1-第一页 2-第二页 不能小于1
        },{
          oldIndex: this.currentDragItemIndex,
          newIndex: newIndex,
          item: this.currentDragItem
        },
        flag => {
          if (flag) {
            // //投放之后 将图片添加到新类别的数组里的，并删除原数据
            // targetImgClsInfo.IMG_DATA.splice(targetIndex + 1, 0, this.currentDragItem);
            // sourceImgClsInfo.IMG_DATA.splice(this.currentDragItemIndex, 1);
            this.cleanPageNums();
          } else {
            consoleLog("分类失败!");
          }
        }
      );
    },
    validateDragDiv (evt) {
      if (evt.dataTransfer.getData("draggable") === "0") {
        evt.dataTransfer.effectAllowed = "none";
        evt.dataTransfer.dropEffect = "none";
        consoleLog("禁止拖放");
        return false;
      } else if (evt.dataTransfer.getData("draggable") === "1") {
        return true;
      }
      return false;
    },
    dragenter (evt, targetIndex, targetImgCls) {
      let imageConTarget = this.getParentNode(evt);
      // consoleLog("dragentercurrentTarget,evt", evt.currentTarget);
      if (evt.target.classList.contains("imagesDiv") || evt.target.classList.contains("imageCon")) {
        //当拖拽元素或选中的文本到一个可释放目标时触发
        // imageConTarget.style.background = " #f3e4cf";
        if (evt.offsetY > evt.target.clientHeight / 2) {
          imageConTarget.classList.remove("drop-up");
          imageConTarget.classList.add("drop-down");
          this.pushDirection = "next";
        } else {
          imageConTarget.classList.remove("drop-down");
          imageConTarget.classList.add("drop-up");
          this.pushDirection = "prev";
        }
        // consoleLog(`dragenter,clientY=${evt.target.clientHeight / 2},evt.offsetY=${evt.offsetY}`);
        return;
      } else if (evt.target.classList.contains("seq")) {
        imageConTarget.classList.remove("drop-up");
        imageConTarget.classList.add("drop-down");
        this.pushDirection = "next";
        // consoleLog("add-down");
      }
      //3秒之后自动清除样式
      setTimeout(() => {
        imageConTarget.classList.remove("drop-up");
        imageConTarget.classList.remove("drop-down");
        // consoleLog("clear");
      }, 3000);
    },
    dragleave (evt, targetIndex, targetImgCls) {
      // consoleLog("dragleave--currentTarget,evt", evt.currentTarget);
      let imageConTarget = this.getParentNode(evt);
      //当拖拽元素或选中的文本离开一个可释放目标时触发
      // imageConTarget.style.background = "#fff";
      imageConTarget.classList.remove("drop-up");
      imageConTarget.classList.remove("drop-down");
      // }
    },
    dragenterPlaceDiv (evt) {
      //当拖拽元素或选中的文本到一个可释放目标时触发
      evt.target.style.background = " #f3e4cf";
    },
    dragleavePlaceDiv (evt) {
      //当拖拽元素或选中的文本离开一个可释放目标时触发
      evt.target.style.background = "#fff";
    },
    noHandleDrapStart (evt) {
      // consoleLog("禁止拖放evt",evt)
      evt.dataTransfer.effectAllowed = "none";
      evt.dataTransfer.dropEffect = "none";
      evt.dataTransfer.setData("draggable", "0");
    },
    beforeClose () {
      // consoleLog("阻止关闭");
      if (this.unknowImgArr[0] && this.unknowImgArr[0].IMG_DATA.length) {
        this.alert("还有待分类影像需要处理");
        //阻止关闭
        return Promise.reject();
      }
      return Promise.resolve();
    },
    //显示大图
    showExamplesFn (obj, index) {
      this.isShowBigImg = true;
      this.bigPageIndex = index;
      this.bigPageObj = obj;
    },
    cancelBigImg () {
      this.isShowBigImg = false;
    },
    getParentNode (evt) {
      if (evt.target.parentNode.classList.contains("imageCon")) {
        return evt.target.parentNode;
      }
      return evt.target;
    },
    async removeImg (imgCls, index) {
      let imgSn = null;
      let delList = [];
      if (imgCls) {
        let item = this.imgClsArr.filter(v => v.IMG_CLS == imgCls);
        item = item && item[0];
        imgSn = item.IMG_SN;
        delList = [item.IMG_DATA[index].PAGE_NUM];
      }
      let successCallback = () => {
        this.cleanPageNums();
      };
      this.$emit("removeImg", imgCls, imgSn, delList, successCallback);
    }
  },
  beforeDestroy () {
    // this.isShow = false;
  }
};
</script>

<style scoped>
.dragBox {
  /* position: fixed;
  overflow: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1010;
  background-color: rgba(55,55,55,.6);
  padding: 20% 10%; */
  /* width: 1172px;
  height: 880px; */
}
.dragBoxModal {
  /* width: 1172px;
  height: 880px; */
}
.dragBoxTip {
  white-space: pre-line;
}
.dragHeader {
  height: 70px;
  margin: 0 0 8px;
}
.dragBox .drag-content {
  display: flex;
  width: 100%;
  max-height: 80%;
  line-height: 20px;
  font-size: 14px;
  color: #17233d;
  font-weight: 500;
  overflow-y: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: white;
  /* top: 20%; */
  position: relative;
  max-height: 900px;
  height: 6rem;
}
.activated {
  border-left-color: #c59041;
  color: #d0aa72;
  background-image: linear-gradient(to right, #f3e4cf, #ffffff);
}
.leftBox {
  width: 27%;
  min-width: 2.5rem;
  display: block;
}
.areaContent {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow-y: scroll;
  justify-content: center;
  align-content: start;
  height: 100%;
  padding-top: 5px;
}
.areaContent .areaContentItem {
  width: 100%;
}
.clsBox {
  height: 80px;
  width: 100%;
  font-size: 18px;
  display: flex;
  padding-left: 20px;
  border-bottom: 1px solid #e8eaec;
  white-space: normal;
  align-items: center;
}
.imgTitle {
  white-space: normal;
  text-align: left;
  line-height: 1.1;
  font-size: 14px;
}
.imgBox {
  width: 19%;
  display: block;
}
/* .imgBox .areaTitle{
  margin-bottom: 10px;
} */
.unknowImgBox {
  width: 54%;
  display: flex;
  align-content: baseline;
  flex-wrap: wrap;
  position: relative;
  height: 100%;
  background: #eeeeee;
  border-radius: 2px;
  padding-top: 42px;
  margin-left: 5px;
}
.unknowImgBox .areaLeft {
  width: 36%;
  height: 100%;
}
.unknowImgBox .areaRight {
  width: 64%;
  height: 100%;
  font-size: 14px;
  color: #d0aa72;
  letter-spacing: 0;
  text-align: center;
  line-height: 16.8px;
  font-weight: 600;
  position: relative;
}
.unknowImgBox .areaRight img {
  height: 95%;
  width: 95%;
}
.unknowImgBox .areaRightmidImgTitle {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.placeHolderDiv {
  width: 98%;
  height: 98%;
  text-align: center;
  line-height: 1;
  /* border: 1px solid #ebeef3; */
}
.imageCon {
  width: 1.8rem;
  height: 1.8rem;
  background: #ffffff;
  border: 1px solid #ebeef3;
  border-radius: 5px;
  display: block;
  text-align: center;
  position: relative;
  white-space: break-spaces;
}
.imageCon .seq {
  display: inline-block;
  text-align: center;
  font-size: 14px;
  height: 20px;
  position: absolute;
  margin: 0 auto;
  bottom: 0;
  left: 0;
  width: 100%;
}
.imageCon .activatedPage {
  color: #d0aa72;
}
.unknowImglist {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  height: 100%;
  justify-content: flex-start;
  overflow-y: scroll;
  flex-wrap: nowrap;
  align-items: center;
  padding-top: 5px;
  padding: 5px 10px 0;
}

.areaTitle {
  border-bottom: 1px solid #f5f7f7;
  width: 100%;
  /* padding: 20px 0; */
  display: flex;
  align-content: space-around;
  font-size: 18px;
  color: #17233d;
  letter-spacing: 0;
  text-align: center;
  font-weight: 600;
  height: 42px;
  flex-wrap: wrap;
  justify-content: center;
  font-weight: 600;
  margin-top: -42px;
}
.unknowTitle {
  justify-content: space-between;
  padding: 0 23px;
  margin-top: -42px;
  border: solid 1px #e0e0e0;
}
.subTitle {
  font-size: 14px;
  color: #696969;
  letter-spacing: 0;
  text-align: right;
  line-height: 16.35px;
  font-weight: 400;
}
.imgClsName {
  width: 100%;
  font-size: 14px;
  font-weight: 400;
}
.commonBox {
  border: 1px solid #ebeef3;
  padding-top: 42px;
}
/** 滑块样式 */
.areaContent::-webkit-scrollbar,
.unknowImglist::-webkit-scrollbar {
  width: 10px;
}

.areaContent::-webkit-scrollbar-thumb,
.unknowImglist::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #d3d3d3;
}
.imagesDiv {
  max-width: 1.8rem;
  max-height: 1.8rem;
  display: block;
  padding-bottom: 20px;
  height: 1.8rem;
  margin: 0 auto;
  box-sizing: border-box;
}
.smallPdf {
  width: 1rem;
  height: 1rem;
  margin: 0.4rem;
}
.uploadListCover {
  display: none;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
}
.unknowImgBox .areaRight .uploadListCover img {
  width: 50px;
  height: 50px;
}
.areaRight:hover .uploadListCover {
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-footer {
  margin-top: 0.5rem;
}
.btns {
  display: flex;
  justify-content: flex-end;
  padding: 0 10px;
}
.btns .btn {
  width: 1rem;
  height: 0.36rem;
  line-height: 0.36rem;
  font-size: 14px;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  margin-left: 0.32rem;
}
.btn.cancel {
  border: 0.5px solid #e3e3e3;
  color: #333333;
}
.btn.confirm {
  background: #dcb369;
  color: #ffffff;
}
@keyframes dropUp {
  100% {
    transform: translateY(-1px) scale(1.01);
    /* margin-top: -15px; */
    background: #f3e4cf;
  }
}
@keyframes dropDown {
  100% {
    transform: translateY(1px) scale(1.01);
    /* margin-top: 10px; */
    /* padding-top: 50px; */
    background: #f3e4cf;
  }
}
.drop-up {
  animation: dropUp 0.5s ease-in-out forwards;
  border-top: 3px dashed red;
}
.drop-down {
  animation: dropDown 0.5s ease-in-out forwards;
  border-bottom: 3px dashed red;
}
</style>



// WEBPACK FOOTER //
// src/components/imageNode/child/dragBox.vue